import { Show } from '@/components';
import Banner from '@/components/banners/banner';
import { hasAllowedRoles } from '@/helpers/roles';
import { CheckFile } from '@/uiComponents/icons';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SelectConfig from './selectedConfig/selectedConfig';

const AdvantageBanner = ({ id, mode, organization, roles, refetchStatus }) => {
  const { t: translate } = useTranslation('translation', { keyPrefix: 'forms.userForm' });
  const { t: tGeneric } = useTranslation('translation', { keyPrefix: 'generic' });
  const advantageNetworkStatus = useWatch({ name: 'advantageNetworkStatus' });
  return (
    <Show.When isTrue={advantageNetworkStatus === 'PENDING' && mode === 'CONCIERGE'}>
      <Banner
        id={id}
        status={advantageNetworkStatus}
        title={translate('banner.title')}
        text={translate('banner.description', {
          name: organization.marketName,
          user: tGeneric('promoter'),
        })}
        icon={<CheckFile size={20} />}
        endComponent={
          hasAllowedRoles(roles, ['superadministrator', 'marketadmin', 'affiliatecenter']) ? (
            <div
              className='d-flex align-items-center justify-content-center'
              style={{ gap: '10px' }}
            >
              <SelectConfig
                status={advantageNetworkStatus}
                id={id}
                usecase='request'
                refetchStatus={refetchStatus}
              />
            </div>
          ) : null
        }
      />
    </Show.When>
  );
};

export default AdvantageBanner;
